import { z } from 'zod';
import { SharedDataRecordSchema } from '../sharedData';
import { ContainerSchema } from './addContainers';

export const ContainerTemplatePayloadV1Schema = z.object({
  name: z.string().trim().min(1),
  containers: z
    .array(
      ContainerSchema.extend({
        date: z.union([ContainerSchema.shape.date, z.literal('')]),
      }),
    )
    .min(1),
});

export const ContainerTemplateSchema = SharedDataRecordSchema.extend({
  namespace: z.literal('container-templates'),
  schemaVersion: z.literal(1),
  data: ContainerTemplatePayloadV1Schema,
});

export type ContainerTemplate = z.infer<typeof ContainerTemplateSchema>;

export const ContainerTemplateContextSchema = z.strictObject({
  partnerDwKey: z.string().min(1),
  workflow: z.enum(['add-container', 'new-location']),
});
export const ContainerTemplateWriteSchema = z.strictObject({
  schemaVersion: z.literal(1),
  data: ContainerTemplatePayloadV1Schema,
});
export const ContainerTemplateCreateSchema = ContainerTemplateContextSchema.extend(
  ContainerTemplateWriteSchema.shape,
);
export const ContainerTemplateUpdateSchema = ContainerTemplateWriteSchema.extend({
  partnerDwKey: z.string().min(1),
  id: z.uuid(),
});
export const ContainerTemplateDeleteSchema = z.strictObject({
  partnerDwKey: z.string().min(1),
  id: z.uuid(),
});
export const ContainerTemplateDiscoverySchema = z.object({
  records: z.array(ContainerTemplateSchema),
});
